<template>
	<div>
		<v-toolbar dense dark color="#f0f0f0" elevation="0">
			<v-spacer />

			<DeliveryOrderMailDialog
				v-if="authority_flag && !delivery_order.send_by_fax && delivery_order.status_type == 'sent'"
				:delivery_order="delivery_order"
				:infosByAddress="infosByAddress"
				:company_name="company_name"
				:user_name="user_name"
				:id="id"
			/>
			<v-btn class="ml-2 print-btn" text color="black" @click="handlePrint()">
				<v-icon class="mr-1">mdi-printer-outline</v-icon>
				印刷</v-btn
			>
		</v-toolbar>
		<div class="pb-4">
			<div class="sheets mt-4" id="sheets">
				<div class="print-sheet" id="print" ref="print">
					<div class="sheet">
						<div class="text-center text-h5 font-weight-bold" style="">配 車 依 頼 書</div>
						<div class="text-right">
							日付　　{{ year(this.delivery_order.order_date) }}年
							{{ month(this.delivery_order.order_date) }}月
							{{ date(this.delivery_order.order_date) }}日
						</div>

						<v-row no-gutters class="mt-4">
							<v-col cols="5" class="pr-1">
								<div class="pa-1 font-14" style="border: 1px solid black; height: 100%">
									{{ this.delivery_order.supplier.name }}<br />{{
										this.delivery_order.supplier.pic_name + "　様"
									}}<br />
									TEL:{{ this.delivery_order.supplier.tell }}
								</div>
							</v-col>
							<v-col cols="4" class="px-1">
								<div class="pa-1 font-14" style="border: 1px solid black; height: 100%">
									極 東 ゴ ム 株式会社
									<br />
									〒590-0904 堺市堺区南島町4-17
									<br />
									TEL　072-232-0467
									<br />
									FAX　072-233-7296
								</div>
							</v-col>
							<v-col cols="3" class="pl-1">
								<div style="border: 1px solid black; height: 100%">
									<table width="100%" style="height: 100%">
										<tbody>
											<tr style="border-bottom: 1px dotted black">
												<td class="text-center" width="50%" style="border-right: 1px dotted black">
													確認
												</td>
												<td class="text-center" width="50%">作成</td>
											</tr>
											<tr height="100%">
												<td class="text-center" style="border-right: 1px dotted black"></td>
												<td></td>
											</tr>
										</tbody>
									</table>
								</div>
							</v-col>
						</v-row>
						<div class="mt-4">
							<table width="100%" style="border: 1px solid black">
								<tbody>
									<tr style="border-bottom: 1px solid black">
										<th
											class="height-48 text-center font-12"
											width="30%"
											style="border-right: 1px solid black"
										>
											手配No
										</th>
										<td class="text-center font-14" width="70%">
											{{ delivery_order.order_number }}
										</td>
									</tr>
									<tr style="border-bottom: 1px solid black">
										<th
											class="height-48 text-center font-12"
											width="30%"
											style="border-right: 1px solid black"
										>
											集荷日
										</th>
										<td class="text-center font-14" width="70%">
											{{ common.formatLocalDate(firstInfo.delivery_info.shipping_date) }}
										</td>
									</tr>
									<tr>
										<th
											class="height-48 text-center font-12"
											width="30%"
											style="border-right: 1px solid black"
										>
											商品名
										</th>
										<td class="text-center font-14" width="70%"><p v-text="product_names" /></td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="mt-4">
							<table width="100%" style="border: 1px solid black">
								<tbody>
									<tr style="border-bottom: 1px solid black">
										<th
											class="height-48 text-center font-12"
											width="15%"
											rowspan="4"
											style="border-right: 1px solid black"
										>
											出荷先
										</th>
										<th
											class="height-48 text-center font-12"
											width="15%"
											style="border-right: 1px solid black"
										>
											社名
										</th>
										<td class="text-center font-14" width="70%">
											{{ firstInfo.delivery_info.company_name }}
										</td>
									</tr>
									<tr style="border-bottom: 1px solid black">
										<th
											class="height-48 text-center font-12"
											width="15%"
											style="border-right: 1px solid black"
										>
											住所
										</th>
										<td class="text-center font-14" width="70%">{{ firstInfo.full_address }}</td>
									</tr>
									<tr style="border-bottom: 1px solid black">
										<th
											class="height-48 text-center font-12"
											width="15%"
											style="border-right: 1px solid black"
										>
											TEL
										</th>
										<td class="text-center font-14" width="70%">
											{{ firstInfo.delivery_info.phone }}
										</td>
									</tr>
									<tr>
										<th
											class="height-48 text-center font-12"
											width="15%"
											style="border-right: 1px solid black"
										>
											着日
										</th>
										<td class="text-center font-14" width="70%">
											{{
												common.formatLocalDate(firstInfo.delivery_info.deadline) +
												" " +
												common.formatLocalTime(firstInfo.delivery_info.deadline_time)
											}}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="mt-4">
							<table width="100%" style="border: 1px solid black">
								<tbody>
									<tr v-for="(car, i) in delivery_order.delivery_order_cars" :key="car.id">
										<th
											class="text-center font-12"
											v-if="i == 0"
											:rowspan="`${
												delivery_order.delivery_order_cars.length < 3
													? 3
													: delivery_order.delivery_order_cars.length
											}`"
											style="border-right: 1px solid black"
										>
											車種 / 台数
										</th>
										<td
											class="height-48 text-center font-14"
											width="70%"
											style="border-bottom: 1px solid black"
										>
											{{ car.car_model }}　　{{ car.number_of_cars }}台
										</td>
									</tr>
									<tr
										v-for="n of 3 - delivery_order.delivery_order_cars.length"
										:key="`blank-${n}`"
									>
										<td
											class="text-center font-14 height-48"
											width="70%"
											style="border-bottom: 1px solid black"
										></td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="mt-4">
							<table width="100%" style="border: 1px solid black">
								<tbody>
									<tr>
										<th
											class="height-48 text-center font-12"
											width="30%"
											style="border-right: 1px solid black"
										>
											備考
										</th>
										<td class="font-14 pa-1" width="70%">
											<p
												v-for="orderIndividualInfo in firstInfo.infos"
												:key="`order-info-${orderIndividualInfo.id}`"
											>
												{{
													orderIndividualInfo.ordered_product.product_number +
													"-" +
													orderIndividualInfo.sub_number
												}}
											</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="mt-4" style="background-color: pink">
							※車番、車種、乗務員、携帯TEL、免許証のコピー（表裏）を、ご連絡ください。
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DeliveryOrderMailDialog from "./components/DeliveryOrderMailDialog.vue"
import common from "../../helper/common"
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"
import moment from "moment"
import "moment/locale/ja"

export default {
	filters: {
		dateFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("YYYY/MM/DD(dd)")
		},
		formatNumber(value) {
			return value.toLocaleString()
		},
	},
	components: {
		DeliveryOrderMailDialog,
	},
	data() {
		return {
			id: this.$route.params.id,
			delivery_order: {
				price: null,
				status_type: null,
				status_type_i18n: null,
				order_date: null,
				number_of_cars: null,
				car_model: null,
				supplier: {
					name: null,
				},
				pic_name: null,
				shipping_place: { name: null },
				memo: null,
				user: {
					full_name: null,
				},
				quote_request: {
					quote_number: null,
				},
				created_at: null,
				updated_at: null,
				delivery_order_individual_infos: [],
				delivery_order_cars: [],
				mail_infos: [],
			},
			product_names: "",
			infosByAddress: [],
			firstInfo: {
				full_address: null,
				delivery_info: {},
				infos: [],
			},
			user_name: null,
			company_name: null,
			authority_flag: false,
			rules,
			common,
			style: initialStyle(),
		}
	},

	mounted() {
		this.fetchDeliveryOrder()
	},
	methods: {
		fetchDeliveryOrder() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/delivery_orders/${this.id}/order_sheets`
			axios
				.get(url, { headers })
				.then((res) => {
					this.delivery_order = res.data.delivery_order
					this.company_name = res.data.company_name
					this.user_name = res.data.user_name
					this.setInfosByAddress()
					this.authority_flag = res.data.authority_flag
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		handlePrint() {
			document.title = `配車依頼書`
			var area = document.getElementById("sheets")
			var htmlDoc = document.body.innerHTML
			document.body.innerHTML = area.innerHTML
			window.print()
			document.body.innerHTML = htmlDoc
			this.$router.go({ path: this.$router.currentRoute.path, force: true })
		},

		setInfosByAddress() {
			this.infosByAddress = this.delivery_order.delivery_order_individual_infos.reduce(
				(groups, current) => {
					const group = groups.find(
						(group) =>
							group.full_address === `${current.prefecture}${current.city}${current.address}`
					)
					if (group) {
						group.infos.push(current.order_individual_info)
					} else {
						groups.push({
							full_address: `${current.prefecture}${current.city}${current.address}`,
							delivery_info: {
								zipcode: current.zipcode,
								prefecture: current.prefecture,
								city: current.city,
								address: current.address,
								fax: current.fax,
								phone: current.phone,
								company_name: current.company_name,
								person_name: current.person_name,
								deadline: current.deadline,
								shipping_date: current.shipping_date,
							},
							infos: [current.order_individual_info],
						})
					}
					return groups
				},
				[]
			)
			// 極東ゴムのフォーマットには一つの住所しか入らないので、一つ目の住所を取得
			this.firstInfo = this.infosByAddress[0]
			const names_with_quantity = this.firstInfo.infos.reduce((groups, current) => {
				const group = groups.find(
					(group) => group.product_number === `${current.ordered_product.product_number}`
				)
				if (group) {
					group.quantity += current.quantity
				} else {
					groups.push({
						product_number: `${current.ordered_product.product_number}`,
						name: current.ordered_product.product.name,
						quantity: current.quantity,
					})
				}
				return groups
			}, [])

			this.product_names = names_with_quantity.reduce((acc, current) => {
				return `${acc} ${current.name}　${current.quantity} 台\n`
			}, "")
		},

		setStyle(styles) {
			let style = {}
			styles.forEach((c) => (style = { ...style, ...this.style[c] }))
			return style
		},
		year(date) {
			if (!date) return ""
			return moment(date).format("YYYY")
		},
		month(date) {
			if (!date) return ""
			return moment(date).format("M")
		},
		date(date) {
			if (!date) return ""
			return moment(date).format("D")
		},
	},
}
function initialStyle() {
	return {
		serif: { fontFamily: "serif, san-serif" },
		borderRight: { borderRight: ".5px solid rgb(110, 52, 52)" },
		borderBottom: { borderBottom: ".5px solid rgb(110, 52, 52)" },
		fontXs: { fontSize: "x-small" },
		textCenter: { textAlign: "center" },
		textRight: { textAlign: "right" },
		verticalTop: { verticalAlign: "top" },
		verticalBottom: { verticalAlign: "bottom" },
	}
}
</script>

<style scoped lang="scss">
@import "../../stylesheet/pdf/paper.scss";

$color: rgb(110, 52, 52);

.sheets {
	* {
		// font-weight: light;
		// font-size: 0.75rem;
	}
}
.serif {
	font-family: serif, sans-serif;
}

.font-9 {
	font-size: 9px;
}

.font-10 {
	font-size: 10px;
}

.font-12 {
	font-size: 11px;
}
.font-12 {
	font-size: 12px;
}
.font-14 {
	font-size: 14px;
}

.height-48 {
	height: 48px;
}

.color-text {
	color: $color;
}
.right-border {
	border-right: 0.5px solid;
}
.left-border {
	border-left: 0.5px solid;
}
.bottom-border {
	border-bottom: 0.5px solid;
	border-color: $color;
}
.no-top-border {
	border-top: 0px solid transparent !important;
}
.text-center {
	text-align: center;
}
.d-flex {
	display: flex;
}
.px-1 {
	padding: 0 4px;
}
.mt-4 {
	margin-top: 1rem;
}
.mt-2 {
	margin-top: 0.5rem;
}
.text-right {
	text-align: right;
}
.text-h5 {
	line-height: 2rem;
	font-family: Roboto, sans-serif !important;
	font-size: 1.5rem !important;
	letter-spacing: normal !important;
}
.font-weight-bold {
	font-weight: 700 !important;
}
.row {
	display: flex;
	flex-wrap: wrap;
	flex: 1 1 auto;
}
.text-justify {
	padding: 0 4px;
	text-align: justify;
	text-align-last: justify;
}
.justify-space-between {
	justify-content: space-between !important;
}
.font-xs {
	font-size: x-small;
}
.vertical-bottom {
	vertical-align: bottom;
}
.vertical-top {
	vertical-align: top;
}
.line-height-narrow {
	line-height: 1.1;
}
.delete-btn {
	right: -2rem;
	top: 0;
	bottom: 0;
}
.delete-page-btn {
	top: 0;
	right: 0;
}

.color-table-wrapper {
	table {
		border: 0.5px solid $color;
	}
	tbody {
		position: relative;
	}
	th,
	td.bg-color {
		background-color: $color !important;
		color: white;
		border-color: white;
	}
	td {
		font-family: serif, sans-serif;
		border-color: $color;
		padding: 0 4px;
		position: relative;
	}
	tr {
		border-color: $color;
	}
}

.print-sheet {
	page-break-after: always;
}

/* hide in print */
@media print {
	#app > :not(.print-sheet) {
		display: none;
	}
	.hide-print {
		display: none;
	}
	body {
		-webkit-print-color-adjust: exact;
	}
}

/* for preview */
@media screen {
	/* mm単位で指定しているけど、vueコンポ側はpx単位なので、無理にmmにしなくてもいいかも。解像度の違いでハマるかも */
	.sheet {
		width: 210mm;
		min-height: 296mm; /* 設定しなくてもいいかも。あまり印刷画面に似せすぎると、些細な違いがバグに見えてしまう */
		margin: 1rem auto;
		padding: 5mm;
		background: white;
		box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3);
	}
}
body {
	-webkit-print-color-adjust: exact;
}

@media print {
	.print-btn {
		display: none;
	}
}
</style>
